import { render, staticRenderFns } from "./CostMain.vue?vue&type=template&id=1f5f7162&scoped=true"
import script from "./CostMain.vue?vue&type=script&lang=js"
export * from "./CostMain.vue?vue&type=script&lang=js"
import style0 from "./CostMain.vue?vue&type=style&index=0&id=1f5f7162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f7162",
  null
  
)

export default component.exports